export default "__VITE_ASSET__Dn$e8EN___"